import React from 'react';
import { Link } from 'react-router-dom';
import Logo2 from '../../assets/Logo2.png';

const PrivacyPolicy = () => {
  return (
    <div className="bg-slate-50 text-slate-800 min-h-screen font-sans selection:bg-blue-200">
      {/* Navigation */}
      <nav className="w-full bg-white/80 backdrop-blur-md border-b border-slate-200 fixed top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6 h-16 flex justify-between items-center">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-11 h-11 bg-white rounded-xl flex items-center justify-center shadow-md shadow-blue-600/20 flex-shrink-0 overflow-hidden">
              <img src={Logo2} alt="ReviewMate logo" className="w-full h-full object-contain rounded-xl scale-150" />
            </div>
            <span className="font-bold text-lg md:text-xl text-slate-900 tracking-tight">ReviewMate</span>
          </Link>
          <div className="flex items-center gap-2 md:gap-4">
            <Link to="/login" className="text-xs md:text-sm font-medium text-slate-600 hover:text-blue-600 px-2 transition-colors">
              Log In
            </Link>
            <Link to="/register" className="bg-blue-600 text-white text-xs md:text-sm font-medium px-4 py-2 md:px-5 md:py-2.5 rounded-full hover:bg-blue-700 transition-all shadow-lg shadow-blue-600/20 hover:shadow-blue-600/40 whitespace-nowrap">
              Get Started
            </Link>
          </div>
        </div>
      </nav>

      {/* Content */}
      <main className="pt-32 pb-20 px-6 max-w-4xl mx-auto">
        <h1 className="text-4xl font-extrabold text-slate-900 mb-8">Privacy Policy</h1>
        <p className="text-slate-500 mb-8">Last Updated: {new Date().toLocaleDateString()}</p>
        
        <div className="space-y-8 text-slate-700 leading-relaxed">
          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">1. Introduction</h2>
            <p>
              Welcome to ReviewMate. We are committed to protecting your personal information and your right to privacy. This Privacy Policy explains what information we collect, how we use it, and your rights in relation to it when you use our educational AI and blockchain platform.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">2. Information We Collect</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Personal Information:</strong> We collect your name, email address, and authentication credentials when you register an account.</li>
              <li><strong>User Content (No PDF Storage):</strong> We process the PDFs, text, and notes you upload for the sole purpose of AI summarization into Reviewers. We <strong>do not collect or store</strong> your uploaded raw PDFs or documents on our servers. They are processed ephemerally and discarded immediately after the Reviewer is generated.</li>
              <li><strong>Usage Data:</strong> We collect data about how you interact with ReviewMate, such as time spent in Study Mode, interactions within Study Groups, and Analytics data to improve your learning experience.</li>
              <li><strong>Blockchain Data:</strong> If you choose to mint Reviewers, a public record of ownership linked to a digital wallet identifier may be recorded on the blockchain.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">3. How We Use Your Information</h2>
            <p className="mb-4">We use your information for the following purposes:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>To provide, operate, and maintain the ReviewMate service.</li>
              <li>To power our AI engine to summarize your documents and generate high-yield reviewers.</li>
              <li>To facilitate Study Groups, Library management, and Board Prep features.</li>
              <li>To generate personalized Analytics and track your learning progress and Achievements.</li>
              <li>To communicate with you regarding updates, security alerts, and support messages.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">4. Sharing Your Information</h2>
            <p>
              We do not sell your personal data. We only share information with third-party service providers (such as AI processing APIs and cloud hosting providers) strictly necessary to operate our Service. When you share Reviewers with Study Groups or publicly, the content of those Reviewers and your display name will be visible to others.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">5. Data Security</h2>
            <p>
              We implement industry-standard security measures to protect your data. However, please remember that no method of transmission over the internet or electronic storage is 100% secure.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">6. Your Privacy Rights</h2>
            <p>
              Depending on your location, you may have the right to access, update, or delete your personal information. You can manage most of your data directly through your Profile settings. To request full account deletion, please contact our support team.
            </p>
          </section>
        </div>

        <div className="mt-16 text-center">
          <Link to="/" className="text-blue-600 hover:underline font-medium">
            &larr; Back to Home
          </Link>
        </div>
      </main>
    </div>
  );
};

export default PrivacyPolicy;
